/*
 * DispoChip Messages
 *
 * This contains all the text for the DispoChip component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'src.pages.ProjectDetailsPage.components.DispoChip';

export default defineMessages({
  dispo: {
    id: `${scope}.dispo`,
    defaultMessage: 'Dispo',
  },
});
